import {AfterViewInit, Directive, ElementRef, Input, OnDestroy, OnInit} from '@angular/core';

import * as $ from 'jquery';
import {KeyboardOptions} from 'virtual-keyboard';
import * as _ from 'lodash';
import {HasPermissionToGuard} from '../../authorization/guards/has-permission-to.guard';
import {HIDE_KEYBOARD} from '../../../../shared/auth/guards/api-permission';

require('virtual-keyboard');

export const GERMAN_LAYOUT = {
  normal: ["̂ 1 2 3 4 5 6 7 8 9 0 ß ́ {bksp}",
    "{tab} q w e r t z u i o p ü +",
    "a s d f g h j k l ö ä # {enter}",
    "{shift} < y x c v b n m , . - {shift}",
    "{a} {alt} {space} {alt} {c}"],
  shift: ['° ! " § $ % & / ( ) = ? ̀ {bksp}',
    "{tab} Q W E R T Z U I O P Ü *",
    "A S D F G H J K L Ö Ä ' {enter}",
    "{shift} > Y X C V B N M ; : _ {shift}",
    "{a} {alt} {space} {alt} {c}"],
  alt: ["̂ 1 ² ³ 4 5 6 { [ ] } \\ ́ {bksp}",
    "{tab} @ w € r t z u i o p ü ̃",
    "a s d f g h j k l ö ä # {enter}",
    "{shift} | y x c v b n µ , . - {shift}",
    "{a} {alt} {space} {alt} {c}"]
};

@Directive({
  selector: '[vbOnScreenKeyboard]'
})
export class OnScreenKeyboardDirective implements OnInit, AfterViewInit, OnDestroy {

  @Input('vbOnScreenKeyboardTouchMode')
  touchMode: boolean = true;

  private hideKeyboard = false;

  private keyboard;

  private _kbOptions: KeyboardOptions = {
    accepted: (e, keyboard, el) => {
      // Dispatch input event to notify angular about changes
      const inputEvent: any = document.createEvent('CustomEvent');
      inputEvent.initEvent('input', true, true);
      el.dispatchEvent(inputEvent);
    },
    //acceptValid: true,
    type: "input",
    layout: 'custom',
    customLayout: {'normal': ['{b} {clear}', '7 8 9', '4 5 6', '1 2 3', '0', '{sp:3}', '{a} {c}']},
    language: 'de',
    stickyShift: false,
    //lockInput: true,
    color: "light",
    updateOnChange: true,
    usePreview: true,
    autoAccept: true,
    caretToEnd: true,
    //tabNavigation: false,
    css: {
      // input & preview styles
      input: 'form-control',
      // keyboard container - this wraps the preview area (if `usePreview` is true)
      // and all keys
      container: 'ui-widget-content ui-widget ui-corner-all ui-helper-clearfix',
      // default keyboard button state, these are applied to all keys, the remaining
      // css options are toggled as needed
      buttonDefault: 'ui-state-default ui-corner-all',
      // hovered button
      buttonHover: 'ui-state-hover',
      // Action keys (e.g. Accept, Cancel, Tab, etc); this replaces the "actionClass" option
      buttonAction: 'ui-state-active',
      // used when disabling the decimal button {dec} when a decimal exists in the input area
      buttonDisabled: 'ui-state-disabled'
    },
  };

  @Input('vbOnScreenKeyboardOptions')
  set kbOptions(value: KeyboardOptions) {
    this._kbOptions = _.merge({}, this._kbOptions, value);
    if (value.customLayout) {
      // If value has custom layout, override layout instead of merging it
      this._kbOptions.customLayout = value.customLayout;
    }
  }

  get kbOptions(): KeyboardOptions {
    return this._kbOptions;
  }

  constructor(private el: ElementRef, private hideKeyboardGuard: HasPermissionToGuard) {
  }

  ngOnInit(): void {
    this.hideKeyboard = this.hideKeyboardGuard.hasPermissionTo(HIDE_KEYBOARD);
  }

  ngAfterViewInit(): void {
    if (this.touchMode && !this.hideKeyboard) {
      this.keyboard = $(this.el.nativeElement)
        .keyboard(this._kbOptions);
    }
  }

  ngOnDestroy(): void {
    if (this.keyboard) {
      this.keyboard.getkeyboard().destroy();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/core/visbos-core/ui/directives/on-screen-keyboard.directive.ts